import React from 'react';

export interface AjustesIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const AjustesIcon: React.FC<AjustesIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.333 21.919v-7m0-4v-7m8 18v-9m0-4v-5m8 18v-5m0-4v-9m-19 11h6m2-6h6m2 8h6"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.919h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default AjustesIcon;
